import React, { useState } from 'react';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import ProjectDetailsModal from './ProjectDetailsModal';

const ProjectTableRow = ({ project }) => {
  const [showModal, setShowModal] = useState(false);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('ar-SA', {
      style: 'currency',
      currency: 'SAR'
    }).format(value);
  };

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {project.projectName}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {project.projectPlace}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {formatCurrency(project.projectValue)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {project.customer}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {project.consultant}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {formatDate(project.orderDate)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          <div className="flex items-center space-x-2 space-x-reverse">
            <button
              className="p-1 text-blue-600 hover:text-blue-800 focus:outline-none"
              title="عرض التفاصيل"
              onClick={() => setShowModal(true)}
            >
              <Visibility className="h-5 w-5" />
            </button>
        
          </div>
        </td>
      </tr>
      {showModal && (
        <ProjectDetailsModal
          project={project}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ProjectTableRow; 